import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs';
import { WebAngularSharedDataAccessFeatureFlagApisService } from '../services/feature-flags.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../services/feature-flags.service";
export class MaintenanceGuard {
    constructor(router, zone, featureFlagsService) {
        this.router = router;
        this.zone = zone;
        this.featureFlagsService = featureFlagsService;
    }
    canActivate() {
        return this.checkIfAppUnderMaintainence().pipe(map((enabled) => {
            if (!enabled) {
                return true;
            }
            this.goToMaintainenceRoute();
            return false;
        }));
    }
    checkIfAppUnderMaintainence() {
        return this.featureFlagsService.getFlagAsync('maintenance-window');
    }
    /**
     * Goes to the maintenance route
     *
     * @memberof MaintainanceGuard
     */
    goToMaintainenceRoute() {
        // Changing route in error handling: https://github.com/angular/angular/issues/15946
        this.zone.run(() => this.router.navigate(['maintenance'], { skipLocationChange: true }));
    }
    static { this.ɵfac = function MaintenanceGuard_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MaintenanceGuard)(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i0.NgZone), i0.ɵɵinject(i2.WebAngularSharedDataAccessFeatureFlagApisService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MaintenanceGuard, factory: MaintenanceGuard.ɵfac }); }
}
//# sourceMappingURL=maintenance.guard.js.map